import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Field } from '@adornis/baseql/decorators.js';
import { Entity } from '@adornis/baseql/decorators/entity.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import type { DataViewConfigKey } from '@ils/static/enums.js';
import { Names } from '@ils/static/names.js';

@Entity()
export class UserConfig extends MongoEntity {
  public static override _class = Names.UserConfig._class;
  public static override _collectionName = Names.UserConfig._collectionName;

  @validate(nonOptional())
  @Field(type => ID)
  public userID: Maybe<string>;

  @validate(nonOptional())
  @Field(type => String)
  public key: Maybe<string>;

  public static getDefault(key: DataViewConfigKey): UserConfig | undefined {
    throw new Error('Tried to call default on abstract class');
  }
}
